import { useSuspenseQuery } from '@apollo/client';
import { useEffect, useReducer } from 'react';
import { client } from '../../../apollo/availability-client';
import { QUERY_ALL_REGIONS_AND_LODGES } from '../graphql/queries';
import { ACTIONS } from './constants';
import { availabilityReducer, initialValue as initialVal } from './reducer';

const useAvailability = (codes, isOpen, initialValue = initialVal) => {
  const [state, dispatch] = useReducer(availabilityReducer, initialValue);
  const { data, error } = useSuspenseQuery(QUERY_ALL_REGIONS_AND_LODGES, {
    client,
    fetchPolicy: 'cache-first',
  });

  // /**
  //  * Need to do some work to prepopulate the form and summary if we are
  //  * looking at a lodge or region.
  //  * */
  useEffect(() => {
    const regions = [];
    const lodges = [];

    if (codes?.region) {
      let name;
      const regions = codes.region.split(',');

      if (data && data.findRegions) {
        regions.forEach((region) => {
          const foundRegion = data.findRegions.find(
            ({ code }) => code === region,
          );
          name = foundRegion ? foundRegion.name : null;

          if (name) {
            regions.push(region);
          }
        });
      }
    }

    if (codes?.lodge && data?.findRegions) {
      let name;
      const foundRegion = data.findRegions.find(({ code }) => code === codes.region);
      
      if (foundRegion && foundRegion.lodges) {
        const foundLodge = foundRegion.lodges.find(({ code }) => code === codes.lodge);
        name = foundLodge ? foundLodge.name : null;
    
        if (name) {
          lodges.push(codes.lodge);
        }
      }
    }
    const regionsList = data?.findRegions ?? [];

    dispatch({
      type: ACTIONS.SET_FORM,
      payload: { regions, lodges, regionsList },
    });
  }, [data, codes, isOpen]);

  return { state, dispatch, data, loading: undefined, error };
};

export default useAvailability;
